import React from 'react';
import './login.css';
// import { Switcher } from "./compoments/switcher"
import { Form, useFetcher } from 'react-router-dom';

 
export async function action({ request, params } : { request: any, params:any } ) {
const formData = await request.formData();;
    console.log(request)
    
    fetch('http://127.0.0.1:3004/v1/user', {
        method: 'POST',
        body: formData,
      })

  }

  function Favorite() {
    const fetcher = useFetcher();
    let favorite = true;
  
    return (
      <fetcher.Form method="post" >
        <button
          name="favorite"
          value={favorite ? "false" : "true"}
          aria-label={
            favorite
              ? "Remove from favorites"
              : "Add to favorites"
          }
        >
          {favorite ? "★" : "☆"}
        </button>
      </fetcher.Form>
    )
  }


const FC: React.FC = () => { 
	return (
        <div id="sign-up">

{/* <Form>
  <label htmlFor="fname">First name:</label><br/>
  <input type="text" id="fname" name="fname"/><br/>
  <label htmlFor="lname">Last name:</label><br/>
  <input type="text" id="lname" name="lname"/>
  <input type="submit" value="Submit"></input>
</Form> */}
            <Form className="cd-form"  method="post">
            <p className="fieldset">
                <label className="image-replace cd-email" htmlFor="signup-email">E-mail</label>
                <input  name="email" className="full-width has-padding has-border" id="signup-email" type="email" placeholder="E-mail"/>
                <span className="cd-error-message">Error message here!</span>
            </p> 


{/*  <Favorite/> */}


            <p className="fieldset">
                <label className="image-replace cd-password" htmlFor="signup-password">Password</label>
                <input className="full-width has-padding has-border" name="password" id="signup-password" type="text" placeholder="Password ( optioneel )"/>
                <a href="#0" className="hide-password">Hide</a>
                <span className="cd-error-message">Error message here!</span>
            </p>

            <p className="fieldset">
                <input type="checkbox" id="accept-terms"/>
                <label htmlFor="accept-terms">I agree to the <a href="#0">Terms</a></label>
            </p>

            <p className="fieldset">
                <input className="full-width has-padding" type="submit" value="Create account" />
            </p> 
        </Form>
    </div>
  );
};
export default FC